let getAccessTokenSilently = null;
let logOutFunction = null

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently(),
  setAccessTokenSilently: (func) => (getAccessTokenSilently = func),
  setLogOut: (func) => (logOutFunction = func),
  logOut: (params) => logOutFunction(params)
};